/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Segment, Form, Input, Button,
  Divider, Dimmer, Loader, Modal, Icon
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class EthernetConfig extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      // Ethernet info
      addr: "",
      netmask: "",
      gateway: "",
      wifiAddr: "",
      wifiNetmask: "",
      hasIpChanged: false,
      updateStatus: Constants.NOT_UPDATING,
      // Dimmers
      isConfigDimmerActive: false,
      isUpdateDimmerActive: false,
      // Modals
      isAlterConfigModalOpen: false,
      isRestartSystemModalOpen: false,
    };

    this.updateLoaderRef = React.createRef();
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      addr: resolvedPromisses[0].addr,
      netmask: resolvedPromisses[0].netmask,
      gateway: resolvedPromisses[0].gateway,
      wifiAddr: resolvedPromisses[1].wifiAddr,
      wifiNetmask: resolvedPromisses[1].wifiNetmask
    });
  }

  // ----------------- Dimmers -----------------
  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true });
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false });

  showConfigDimmer = () => this.setState({ isConfigDimmerActive: true });
  hideConfigDimmer = () => this.setState({ isConfigDimmerActive: false });

  openAlterConfigModal = () => this.setState({ isAlterConfigModalOpen: true });
  closeAlterConfigModal = () => this.setState({ isAlterConfigModalOpen: false });

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  // ----------------- Form Change -----------------
  handleAddressChange = (e, { value }) => {
    this.setState({ addr: value });
  }

  handleMaskChange = (e, { value }) => {
    this.setState({ netmask: value });
  }

  handleGatewayChange = (e, { value }) => {
    this.setState({ gateway: value });
  }

  // Sends the modified network information to be processed
  sendConfigInformation = async () => {
    this.closeAlterConfigModal();

    // Aqui removemos todos os zeros à esquerda para evitar erros no netplan
    let cleanedIp = UtilsInstance.removeLeadingZeros(this.state.addr, UtilsInstance);
    let cleanedNetmask = UtilsInstance.removeLeadingZeros(this.state.netmask, UtilsInstance);
    let cleanedGateway = UtilsInstance.removeLeadingZeros(this.state.gateway, UtilsInstance);

    let isIpValid = UtilsInstance.validateIPAddress(cleanedIp);
    let isZeroIp = UtilsInstance.isZeroIP(cleanedIp);
    let isNetmaskZeroIp = UtilsInstance.isZeroIP(cleanedNetmask);
    let isIPLoopback = UtilsInstance.isIPLoopback(cleanedIp);
    let isBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedIp, cleanedNetmask, UtilsInstance);
    let isNetworkIp = UtilsInstance.isNetworkAddress(cleanedIp, cleanedNetmask, UtilsInstance);
    let isSubmaskValid = UtilsInstance.validateSubmask(cleanedNetmask);
    let isGatewayValid = UtilsInstance.validateIPAddress(cleanedGateway);
    let isGatewayBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedGateway, cleanedNetmask, UtilsInstance);
    let isGatewayNetworkIp = UtilsInstance.isNetworkAddress(cleanedGateway, cleanedNetmask, UtilsInstance);

    console.log("wifiAddr: ", this.state.wifiAddr);
    console.log("wifiNetmask: ", this.state.wifiNetmask);

    let subnetsOverlap = UtilsInstance.subnetsOverlap(
      cleanedIp,
      cleanedNetmask,
      this.state.wifiAddr,
      this.state.wifiNetmask,
      UtilsInstance
    );

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid
      || isZeroIp
      || isNetmaskZeroIp
      || isIPLoopback
      || isBroadcastIp
      || isNetworkIp
      || !isSubmaskValid
      || !isGatewayValid
      || isGatewayBroadcastIp
      || isGatewayNetworkIp
      || subnetsOverlap) {

      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }

      if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP);
      }

      if (isZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MSG);
      }

      if (isNetmaskZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MASK_MSG);
      }

      if (isBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_IP_MSG);
      }

      if (isNetworkIp && !isZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_IP_MSG);
      }

      if (!isSubmaskValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_SUBMASK);
      }

      if (!isGatewayValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_GATEWAY);
      }

      if (isGatewayBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_GATEWAY_MSG);
      }

      if (isGatewayNetworkIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_GATEWAY_MSG);
      }

      if (isIpValid
        && !isIPLoopback
        && !isZeroIp
        && !isNetmaskZeroIp
        && !isBroadcastIp
        && !isNetworkIp
        && isSubmaskValid
        && isGatewayValid
        && !isGatewayBroadcastIp
        && !isGatewayNetworkIp
        && subnetsOverlap) {
        invalidInformationString = invalidInformationString.concat(Strings.SUBNET_OVERLAP_ETHERNET_WLAN);
      }

      alert(invalidInformationString);
    }
    else {
      let gtway = "";

      if (cleanedGateway === "") {
        gtway = "0.0.0.0";
      } else {
        gtway = cleanedGateway;
      }

      let data = JSON.stringify({
        addr: cleanedIp,
        netmask: cleanedNetmask,
        gateway: gtway,
      });

      // Get the old configuration data to compare with the new
      // We will need to restart the monitor depending on what was modified
      let previousConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // Check if the IP has changed and save this comparison as a state to be used later
      this.setState({ hasIpChanged: cleanedIp !== previousConfigData.addr }, () => {

        // If nothing was modified, alert the user and do nothing else
        if (cleanedIp === previousConfigData.addr
          && gtway === previousConfigData.gateway
          && cleanedNetmask === previousConfigData.netmask) {
          alert(Strings.CHANGE_AT_LEAST_ONE_OF_THE_FIELDS);
        }
        // If the IP / gateway / mask was modified, we need to handle the update in another way
        else {
          this.showConfigDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "config_POST", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            },
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles();
            })
            .catch((error) => {
              alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
            })
            .finally(this.hideConfigDimmer);
        }
      });
    }
  }

  handleUpdateCycles = () => {
    this.showUpdateDimmer();
    let intervalID = -1;

    intervalID = setInterval(this.handleAlterConfigurationStatus, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleAlterConfigurationStatus = () => {
    if (this.state.hasIpChanged && this.state.updateStatus === Constants.RESTARTING_MONITOR) {
      let newAddress = "http://" + this.state.addr + ":5000/updateStatus";

      fetch(newAddress, { mode: "cors" })
        .then(res => res.json())
        .then((data) => {

          //console.log("Status atual da tela: ", this.state.updateStatus);
          //console.log("Data update Status: ", data.update);

          if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
            this.setState({ updateStatus: data.update }, () => {
              this.updateLoaderRef.current.changeLoaderText(Strings.RESTARTING_MONITOR_WAIT);
            });
          }
          else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
            this.setState({ updateStatus: data.update }, () => {
              this.updateLoaderRef.current.changeLoaderText("");
              this.hideUpdateDimmer();
              clearInterval(this.state.intervalID);
              alert(
                Strings.UPDATE_INTERFACE_CONFIG_SUCCESS + Strings.REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO + UtilsInstance.removeLeadingZeros(this.state.addr, UtilsInstance)
              );
              this.retrieveData();
            });
          }
        })
        .catch((error) => {
          console.log(Strings.UPDATE_ERROR_STRING + error);
        });
    }
    else {
      fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
        .then(res => res.json())
        .then((data) => {

          // console.log("Status atual da tela: ", this.state.updateStatus);
          // console.log("Data update Status: ", data.update);

          if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
            this.setState({ updateStatus: data.update }, () => {
              this.updateLoaderRef.current.changeLoaderText(Strings.RESTARTING_MONITOR_WAIT);
            });
          }
          else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
            this.setState({ updateStatus: data.update }, () => {
              this.updateLoaderRef.current.changeLoaderText("");
              this.hideUpdateDimmer();
              alert(Strings.UPDATE_INTERFACE_CONFIG_SUCCESS);
              this.retrieveData();
            });
          }
        })
        .catch((error) => {
          console.log(Strings.UPDATE_ERROR_STRING + error);
        });
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    this.setState({ updateStatus: Constants.NOT_UPDATING });
  }

  render() {
    const isConfigDimmerActive = this.state.isConfigDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;

    return (
      <div style={configStyle}>

        <Segment>
          <Divider horizontal>{Strings.INTERFACE_CONFIG}</Divider>
          <Form style={formStyle} onSubmit={this.openAlterConfigModal}>

            <Form.Field inline>
              <label style={labelStyle}>{Strings.IP}</label>
              <Input style={inputStyle}
                placeholder='192.168.0.2'
                value={this.state.addr}
                onChange={this.handleAddressChange} />
            </Form.Field>

            <Form.Field inline>
              <label style={labelStyle}>{Strings.SUBMASK}</label>
              <Input style={inputStyle}
                placeholder='255.255.255.0'
                value={this.state.netmask}
                onChange={this.handleMaskChange} />
            </Form.Field>

            <Form.Field inline>
              <label style={labelStyle}>{Strings.GATEWAY}</label>
              <Input style={inputStyle}
                placeholder='192.168.0.1'
                value={this.state.gateway}
                onChange={this.handleGatewayChange} />
            </Form.Field>

            <Button color="teal" type="submit" >{Strings.SETUP}</Button>
          </Form>
          <Dimmer active={isConfigDimmerActive} >
            <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
          </Dimmer>
        </Segment>

        <Modal centered basic size='small' open={this.state.isAlterConfigModalOpen}>
          <Modal.Content content={Strings.ALTER_MONITOR_CONFIG} />
          <Modal.Actions>
            <Button color='red' inverted onClick={this.closeAlterConfigModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button color='green' inverted onClick={this.sendConfigInformation}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>

      </div>
    );
  }
}

const configStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

export default withRouter(EthernetConfig);